import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'table-container-body',
  templateUrl: './table-container-body.component.html',
})
export class TableContainerBodyComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
